import RandomColor from "../../../../content/blog/mdx/random-color";
import * as React from 'react';
export default {
  RandomColor,
  React
};